import { ApiService } from '../../core/services/api.service';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Store } from 'src/app/core/services/store.service';
import { Message } from '../models/messages.model';

@Injectable({
  providedIn: 'root',
})
export class MessagesStoreService extends Store<Message> implements OnDestroy {
  private unsubscribe = new Subject();

  constructor(private api: ApiService) {
    super(null);
    this.subscribeWebSocketMessages();
  }

  private subscribeWebSocketMessages() {
    this.api
      .subscribe<Message>('dialog-message')
      .pipe(
        takeUntil(this.unsubscribe),
        tap((socketFrame) => {
          this.setState(socketFrame);
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

}
